module.exports = __webpack_public_path__ + "img/skybox.855c7fda.jpg";